import request from './request'

// //课程锁定的导出数据
// export function _courseAdd(data = {}) {
//     const config = Object.assign(data, {
//       method: 'post',
//       url: '/admin/course/add',
//     })
//     return request(config)
// }

// //求合作的导出数据
// export function _courseAdd(data = {}) {
//     const config = Object.assign(data, {
//       method: 'post',
//       url: '/admin/excel/collect',
//     })
//     return request(config)
// }

//导出音频
export function _exportAudioFile(data = {}) {
  const config = Object.assign(data, {
    method: 'get',
    url: '/admin/course/audio-export',
  })
  return request(config)
}

